import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index'
import QuestionList from './question/list'
import QuestionEditor from './question/editor'
import StepList from './step/list'
import StepEditor from './step/editor'
import QuestionnaireList from './questionnaire/list'
import QuestionnaireEditor from './questionnaire/editor'
import MicroSiteList from './microSite/list'
import MicroSiteEditor from './microSite/editor'
import BlankLayout from '../../layout/blankLayout.vue'

const basePath = '/v-admin/satisfaction-survey-management'
const notificationManagementPath = '/v-admin/notification-management/notification/list'
const i18nPrefix = 'admin.company.satisfactionSurvey'

const MicroSiteEditRoute = {
  path: `${basePath}/micro-site`,
  redirect: `${basePath}/micro-site/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.microSite.edit`,
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.microSite` }
  },
  children: [
    {
      path: `${basePath}/micro-site/edit/:microSiteId`,
      component: MicroSiteEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.microSite.edit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/micro-site/add`,
      component: MicroSiteEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.microSite.add`,
        isEditMode: false
      }
    }
  ]
}

const QuestionEditRoute = {
  path: `${basePath}/question`,
  redirect: `${basePath}/question/list`,
  component: BlankLayout,
  meta: {
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.question` }
  },
  children: [
    {
      path: `${basePath}/question/edit/:questionId`,
      component: QuestionEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.question.edit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/question/add`,
      component: QuestionEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.question.add`,
        isEditMode: false
      }
    }
  ]
}

const StepEditRoute = {
  path: `${basePath}/step`,
  redirect: `${basePath}/step/list`,
  component: BlankLayout,
  meta: {
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.step` }
  },
  children: [
    {
      path: `${basePath}/step/edit/:stepId`,
      component: StepEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.step.edit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/step/add`,
      component: StepEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.step.add`,
        isEditMode: false
      }
    }
  ]
}

const QuestionnaireEditRoute = {
  path: `${basePath}/questionnaire`,
  redirect: `${basePath}/questionnaire/list`,
  component: BlankLayout,
  meta: {
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.questionnaire` }
  },
  children: [
    {
      path: `${basePath}/questionnaire/edit/:questionnaireId`,
      component: QuestionnaireEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.questionnaire.edit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/questionnaire/add`,
      component: QuestionnaireEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.questionnaire.add`,
        isEditMode: false
      }
    }
  ]
}

const EmailTemplateLegacyRoute = {
  path: `${basePath}/email-template`,
  redirect: notificationManagementPath,
  component: BlankLayout,
  children: [
    {
      path: `${basePath}/email-template/edit/:emailTemplateId`,
      redirect: notificationManagementPath
    },
    {
      path: `${basePath}/email-template/add`,
      redirect: notificationManagementPath
    },
    {
      path: `${basePath}/email-template/list`,
      redirect: notificationManagementPath
    }
  ]
}

export const tabMenuRoute = {
  path: `${basePath}`,
  redirect: `${basePath}/micro-site/list`,
  component: Index,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.management`,
    breadcrumb: { hidden: true }
  },
  children: [
    {
      path: `${basePath}/micro-site/list`,
      component: MicroSiteList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.microSite`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.microSite` }
      }
    },
    {
      path: `${basePath}/question/list`,
      component: QuestionList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.question`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.question` },
        showLocale: true
      }
    },
    {
      path: `${basePath}/step/list`,
      component: StepList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.step`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.step` },
        showLocale: true
      }
    },
    {
      path: `${basePath}/questionnaire/list`,
      component: QuestionnaireList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.questionnaire`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.questionnaire` }
      }
    }
  ]
}

export default {
  path: `${basePath}`,
  component: Layout,
  meta: {
    permission: ['PREMIUM_SATISFACTION_SURVEY', 'PERM_SATISFACTION_SURVEY_MANAGE'],
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: `${i18nPrefix}.title.management`,
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.menu.management`)
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    tabMenuRoute,
    MicroSiteEditRoute,
    QuestionEditRoute,
    StepEditRoute,
    QuestionnaireEditRoute,
    EmailTemplateLegacyRoute
  ]
}
